import { useState, useEffect } from 'react'
import fetch from '@adc/fetch'

export const useReadRequest = (initialUrl, initialData) => {
  const [data, setData] = useState(initialData)
  const [url, setUrl] = useState(initialUrl)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    async function fetchData() {
      setIsError(false)
      setIsLoading(true)

      try {
        const res = await fetch(url)
        setData(res.body)
      } catch (error) {
        setIsError(true)
      }

      setIsLoading(false)
    }

    fetchData()
  }, [url])

  // Idea behind this is that for fetching new data, the id will change, and so the url
  // itself will change.
  const execute = setUrl

  return {
    data,
    execute,
    isLoading,
    isError,
  }
}
